import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ExamByLaw = () => {
  const { oppositionName } = useParams();
  const navigate = useNavigate();
  const [laws, setLaws] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLaws = async () => {
      try {
        const response = await axios.get(`/api/laws/${oppositionName}`);
        setLaws(response.data);
      } catch (error) {
        console.error('Error fetching laws', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLaws();
  }, [oppositionName]);

  if (loading) return <div className="page-loader">Cargando leyes…</div>;

  return (
    <div>
      <button
        onClick={() => navigate(`/oposicion/${oppositionName}`)}
        className="back-link"
      >
        ← Volver
      </button>

      <header className="page-header">
        <h1 className="page-title">Examen por ley</h1>
        <p className="page-subtitle">
          {oppositionName} · Selecciona una ley para practicar
        </p>
      </header>

      {laws.length === 0 ? (
        <div className="empty-state">
          <p>No hay leyes con preguntas disponibles.</p>
        </div>
      ) : (
        <div className="list-grid">
          {laws.map((law, index) => (
            <Link
              key={index}
              to={`/exam/law/${encodeURIComponent(law)}`}
              className="list-item"
            >
              <span className="list-item-title">{law}</span>
              <span className="list-item-arrow">→</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExamByLaw;
